// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xgeh","field":"styles_field__1bVLw","fieldCol":"styles_fieldCol__3L4Yd","diffCol":"styles_diffCol__bBXNv","diff":"styles_diff__2pAox"};